import { defineComponent as _defineComponent } from 'vue'
import { AUTH_FLOW_STEPS } from "~/core/services/utils/Constants";
import { computed, useContext } from "@nuxtjs/composition-api";


export default /*#__PURE__*/_defineComponent({
  __name: 'TwoFASwitcher',
  setup(__props) {

const context = useContext();
const user = computed(() => context.store.getters['application/driver/authUser']);

const handleOpen = () => {
    context.store.dispatch('application/driver/setAuthStep', AUTH_FLOW_STEPS.TWO_FACTOR_CODE);
    context.store.dispatch('application/popup-control/changeConnectWalletPopupStatus', true);
}

return { __sfc: true,context, user, handleOpen }
}

})